import { ReactNode } from 'react';
import { ApiError } from '../../../common/types-api';
import { BouPageWithFrame } from '../../common/generic/layout/bou-tool-page-with-frame';
import { useGetLoggedInUser } from '@upright/ui/common/generic/hooks';
import { useInUnifiedShellFrame } from '../unified-shell/unified-shell-frame';
import { useUnifiedShell } from '../unified-shell/use-unified-shell';
import { PageState, usePageHomeHref } from './page-state';
import { errorPageState } from './error-page-state';
import { PageType } from './types';

interface Props {
  error?: ApiError;
  pageType: PageType;
  sideBarContent?: ReactNode;
  onRetry?: () => Promise<unknown>;
}

export const ErrorPage = (props: Props) => {
  const inUnifiedFrame = useInUnifiedShellFrame();
  const unifiedShell = useUnifiedShell();
  const homeHref = usePageHomeHref();
  const signedOut = !useGetLoggedInUser();
  const state = errorPageState(
    props.pageType === 'my-portfolios' || props.pageType === 'unauthorized' ? 403 : props.error?.status,
    props.pageType === 'generic',
    signedOut,
    props.pageType,
  );
  const content = (
    <PageState {...state} homeHref={homeHref} onRetry={state.retry ? (props.onRetry ?? reloadPage) : undefined} />
  );
  // A user in the unified shell never gets the legacy frame around it. Outside the shell's frame the
  // page stands alone: under the white bar the header switch pins over the routes the frame does not
  // wrap, or on its own when the app-wide error boundary (`AppError`) has replaced a framed route.
  // It does not mount the frame there, so a crash in the frame cannot take its error page down too.
  if (inUnifiedFrame || unifiedShell.enabled) return content;
  return (
    <BouPageWithFrame
      hasTitleBar={false}
      hideSideBar={props.sideBarContent ? false : true}
      sideBarContent={props.sideBarContent}
    >
      {content}
    </BouPageWithFrame>
  );
};

function reloadPage() {
  window.location.reload();
}
